export const os = (() => {
  const ua = navigator.userAgent;
  const isWindowsPhone = /(?:Windows Phone)/.test(ua);
  const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
  const isAndroid = /(?:Android)/.test(ua);
  const isFireFox = /(?:Firefox)/.test(ua);
  const isChrome = /(?:Chrome|CriOS)/.test(ua);

  const isTablet =
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua));

  const isPhone = /(?:iPhone)/.test(ua) && !isTablet;
  const isPc = !isPhone && !isAndroid && !isSymbian;

  const isWeChat =
    /MicroMessenger/.test(navigator.userAgent) && !/WindowsWechat/.test(navigator.userAgent);
  const isIOS = navigator.userAgent.indexOf('iP') > -1;
  const isPC = !/(iPhone|iPod|Android|ios)/i.test(navigator.userAgent);

  return {
    isAndroid,
    isChrome,
    isIOS,
    isTablet,
    isPc,
    isPhone,
    isWeChat,
    isPC
  };
})();

declare const wx: any;

export type NetworkType = '2g' | '3g' | '4g' | 'wifi';
export function getNetworkType(): Promise<NetworkType> {
  if (os.isPc) {
    return Promise.resolve<NetworkType>('wifi');
  } else if (
    window.navigator &&
    (window.navigator as any).connection &&
    (window.navigator as any).connection.effectiveType
  ) {
    // 普通 html5
    return Promise.resolve<NetworkType>((window.navigator as any).connection.effectiveType);
  } else if (typeof wx !== 'undefined') {
    // 微信拍断
    return new Promise((resolve) =>
      wx.ready(() => wx.getNetworkType({ success: (res: any) => resolve(res.networkType) }))
    );
  } else {
    return Promise.resolve<NetworkType>('wifi');
  }
}



// WEBPACK FOOTER //
// ./src/services/lib/os.ts